import Mapbox from 'index.vue';

export class BaseLayer {

    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected slot: any = null;
    constructor(mapboxInstance: InstanceType<typeof Mapbox>,slot: any) {
        this.mapboxInstance = mapboxInstance;
        this.slot = slot;
    }
    
    public LoadImages(urls: Set<string>) {
        const uniqueIcons = Array.from(urls);
        return [...uniqueIcons].map(async (iconUrl) => {
            if (!this.mapboxInstance.map.hasImage(iconUrl)) {
                try {
                    const response = await fetch(iconUrl);
                    if (!response.ok) return;
                    const blob = await response.blob();
                    const bitmap = await createImageBitmap(blob);
                    if (!this.mapboxInstance.map.hasImage(iconUrl)) {
                        this.mapboxInstance.map.addImage(iconUrl, bitmap as any, { pixelRatio: 2 });
                    }
                } catch (error: any) {
                    if (!error?.message?.includes('already exists')) {
                        console.error(`Error loading image: ${iconUrl}`, error);
                    }
                }
            }
        });
    }
}